// extracted by mini-css-extract-plugin
module.exports = {"c-update-password-tab__form":"UpdatePasswordTab_c-update-password-tab__form__T1r_i"};